import { httpClient } from '@/lib/httpClient';

export interface CreateAppTokenDto {
  name: string;
}

export interface CreateAppTokenResponseDto {
  token: string;
}

export interface AppToken {
  id: number;
  name: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateActiveDto {
  active: boolean;
}

class AppTokensService {
  constructor() {}
  async createAppToken(createAppTokenDto: CreateAppTokenDto) {
    const { data } = await httpClient.post<CreateAppTokenResponseDto>(
      '/v1/app-tokens',
      createAppTokenDto,
    );
    return data;
  }
  async getAppTokens() {
    const { data } = await httpClient.get<AppToken[]>('/v1/app-tokens');
    return data;
  }

  async getAppTokenById(id: number) {
    const { data } = await httpClient.get<AppToken>(`/v1/app-tokens/${id}`);
    return data;
  }

  async removeAppToken(id: number) {
    await httpClient.delete<void>(`/v1/app-tokens/${id}`);
  }

  async updateAppToken(id: number, updateActiveDto: UpdateActiveDto) {
    const { data } = await httpClient.patch<AppToken>(
      `/v1/app-tokens/${id}/active`,
      updateActiveDto,
    );
    return data;
  }
}

export default new AppTokensService();
